import { createStyles } from '@mui/styles';
import { APTheme } from '../../../../core/TenantProvider/tenants';

export default (theme: APTheme) => createStyles({
  lookupContainer: {
    marginBottom: 25,
    '& .autocomplete': {
      position: 'relative'
    },
    '&:last-child': {
      marginBottom: 0
    }
  },
  lookupContainerFocused: {
    '& .autocomplete .MuiOutlinedInput-notchedOutline': {
      borderBottomRightRadius: 0,
      borderBottomLeftRadius: 0,
      // borderBottom: 0
    }
  },
  lookupContainerSelected: {

  },
  lookupInput: {
    marginBottom: 0,
    width: '100%',
    marginTop: 25
  },
  lookupResults: {
    backgroundColor: '#FFF',
    border: '1px solid #2D91E9',
    borderWidth: '0 2px 2px 2px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    listStyle: 'none',
    margin: 0,
    padding: '0 15px 15px',
    position: 'absolute',
    top: 76,
    width: '100%',
    zIndex: 100,
    height: '250px',
    overflowY: 'scroll'
  },
  lookupResultsItem: {
    display: 'flex',
    justifyContent: 'space-between',
    color: '#4A4A4A',
    cursor: 'pointer',
    fontSize: '1.5rem',
    marginBottom: 5,
    padding: 5,
    lineHeight: 1.5,
    '&:last-child': {
      marginBottom: 0
    },
    '&:hover': {
      backgroundColor: '#2D91E9',
      color: '#FFF',
      '& svg':{
          '& path': {
            fill: '#fff'
          }
      }
    },
    '& svg':{
      position: 'relative',
      top: '0px',
      left: '0px'
    }
  },
  lookupResultsItemSelected: {
    backgroundColor: '#2D91E9',
    color: '#FFF'
  },
  manualEntryContainer: {
    marginTop: 25,
  },
  countySelect: {
    position: 'relative',
    marginBottom: '25px'
  },
  manualInput: {
    width: '100%',
    '&:last-child': {
      marginBottom: 0
    },
  },
  selectionSummary: {
    backgroundColor: '#f5f5f5',
    marginTop: 25,
    padding: 25
  },
  textButton: {
    minWidth: 'auto',
    padding: 0,
    marginTop: 15,
    height: 'auto',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  summaryLabel: {
    color: '#A4A4A4',
    fontSize: 14,
    marginBottom: 5
  },
  loadingIcon: {
    position: 'absolute',
    right: 15,
    top: 40
  }
});